<template>
  <div class="advanced-search-container">
    <el-dialog
      title="高级搜索"
      :width="device === 'desktop' ? '1100px' : '520px'"
      :style="{
        padding: device !== 'desktop' ? '0px' : '',
        margin: device !== 'desktop' ? '0px' : '',
      }"
      :model-value="modelValue"
      @close="closed"
    >
      <Card
        title="常用查询"
        class="mb20"
        v-show="commonSearchItems.length > 0"
        :style="{
          padding: device !== 'desktop' ? '0px' : '',
          margin: device !== 'desktop' ? '0px' : '',
        }"
      >
        <el-row :gutter="8">
          <template v-for="comItem in commonSearchItems">
            <el-col :span="12">
              <el-checkbox-group v-model="commonCheckList">
                <el-checkbox :label="comItem.prop">
                  <div class="common-label-container">{{ comItem.label }}</div>
                  <value-item-vue
                    :search-type="comItem"
                    v-model="commonVals[comItem.prop]"
                  />
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </template>
        </el-row>
      </Card>
      <Card
        title="常规查询"
        class="mb10"
        :style="{
          padding: device !== 'desktop' ? '0px' : '',
          margin: device !== 'desktop' ? '0px' : '',
        }"
      >
        <div class="header-btn">
          <div class="add-btn" @click="addSearchItem">
            <svg-icon iconClass="add1"></svg-icon>
            <span>&nbsp;增加</span>
          </div>
        </div>
        <div class="search-item-container">
          <el-row :gutter="8">
            <template v-for="(item, index) in searchItems">
              <el-col :span="device === 'desktop' ? 12 : 24">
                <div class="item-container" v-if="item[2]">
                  <search-item
                    :table-columns="tableColumns"
                    :search-index="index"
                    :default-type="Array.isArray(item[0]) ? item[3] : item[0]"
                    :default-val="item[1]"
                    :is-show="item[2]"
                    :reset="reset"
                    @updateVal="updateSearchVal"
                    @removeItem="removeSearchItem"
                  ></search-item>
                </div>
              </el-col>
            </template>
          </el-row>
        </div>
      </Card>
      <template #footer>
        <dialog-foot-btn @onClosed="closed" @onConfirm="onConfirm">
        </dialog-foot-btn>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import DialogFootBtn from "@/components/Element/DialogFootBtn";

import SearchItem from "./searchItem.vue";
import valueItemVue from "./valueItem.vue";
import { onMounted, ref, watch, computed } from "vue";
import useSettingsStore from "@/store/modules/settings";
import Card from "@/components/Element/Card";

import useAppStore from "@/store/modules/app";

const device = computed(() => useAppStore().device);

const settingsStore = useSettingsStore();
const props = defineProps({
  // 是否显示高级搜索框
  modelValue: {
    type: Boolean,
    required: true,
  },
  // 可以搜索测列
  tableColumns: {
    type: Array,
    required: true,
  },
  // 重置参数
  reset: {
    required: false,
    type: Boolean,
    default: false,
  },
  // 初始搜索参数
  initialSearchParams: {
    required: false,
    type: Array,
    default: [],
  },
});

const commonCheckList = ref([]);
const commonVals = ref({});
// 常用查询项
const commonSearchItems = computed(() => {
  return props.tableColumns.filter((item) => {
    if (item.commonSearch) {
      commonVals[item.prop] = "";
    }
    return item.commonSearch;
  });
});

const searchItems = ref([["", "", true]]);
const initialSearchParamsFn = () => {
  searchItems.value = [];
  commonCheckList.value = [];
  commonVals.value = {};
  if (props.initialSearchParams.length > 0) {
    for (let item of props.initialSearchParams) {
      if (item[0] === "readingTime") {
        searchItems.value.push(["readingTime", item[1], true]);
      }
    }
  } else {
    searchItems.value = [["", "", true]];
  }
};
initialSearchParamsFn(); // 初始化搜索参数
const emits = defineEmits(["update:modelValue", "onSearch"]);

// 增加搜索item
const addSearchItem = () => {
  searchItems.value.push(["", "", true]);
};
// 移除搜索项
const removeSearchItem = (itemIndex) => {
  searchItems.value[itemIndex][2] = false;
};

/**
 * 更新搜索的值
 */
const updateSearchVal = (index, type, val) => {
  if (searchItems.value.length >= index) {
    searchItems.value[index][0] = type;
    searchItems.value[index][1] = val;
  } else {
    // console.log('下标超限',searchItems,index)
  }
};

/**
 * 确定
 */
const onConfirm = (exectSearch = true) => {
  // 过滤删除的搜索项
  const searchVal = searchItems.value.filter((item) => item[2]);
  commonCheckList.value.forEach((item) => {
    if (commonVals.value[item]?.type && commonVals.value[item]?.val) {
      searchVal.push([commonVals.value[item].type, commonVals.value[item].val]);
    } else {
      searchVal.push([item, ""]);
    }
  });
  emits("onSearch", searchVal, exectSearch);
  closed();
};

/**
 * 关闭
 */
const closed = () => {
  //清楚搜索条件
  // searchItems.value = [['','',true]]
  // 给父组件发送信号
  emits("update:modelValue", false);
};

const theme = ref(settingsStore.theme);

onMounted(() => {
  watch(
    () => props.reset,
    (newVla) => {
      initialSearchParamsFn(); // 初始化搜索参数
      onConfirm(false);
    }
  );
  watch(
    () => settingsStore.theme,
    (newVal) => {
      theme.value = newVal;
    }
  );
  onConfirm(false);
});
</script>

<style lang="scss" scoped>
.advanced-search-container {
  :deep(.el-dialog__body) {
    padding-top: 10px;
  }
  .common-label-container {
    display: inline-block;
    position: relative;
    top: 2px;
    width: 150px;
    height: 32px;
    line-height: 32px;
    font-size: 16px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #e4e7ed;

    &:hover {
      border: 1px solid #c0c4cc;
    }
    &:active {
      border: 1px solid #409eff;
    }
  }

  .search-item-container {
    min-height: 200px;
    .el-select {
      width: 200px;
    }
  }
  .header-btn {
    display: flex;
    .add-btn {
      display: inline-block;
      cursor: pointer;
    }
    .add-btn:hover {
      color: v-bind(theme);
    }
  }
  .item-container {
    height: 33px;
    margin-top: 5px;
  }
}
</style>
